/**
 * 发票管理相关接口
 * @date 2024-8-20
 * @Author: GuanHanTao
 */
import request from "@/utils/request";

// 报销模块中获取发票管理中的发票列表
export function querySelf(params) {
    return request({
        url: '/invoice/querySelf',
        headers: {
            isToken: true,
        },
        method: 'get',
        params,
    })
}

// 发票管理中的发票列表
export function list(params) {
    return request({
        url: '/invoice/list',
        headers: {
            isToken: true,
        },
        method: 'get',
        params,
    })
}


// OCR识别服务
export function OCR_upload(data) {
    return request({
        url: 'https://ocr.admin-stage-api.store/upload',
        method: 'post',
        data
    })
}

// 发票管理提交
export function invoice(params) {
    return request({
        url: '/work/invoiceInfo/validateInvoice',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}

// 发票抬头列表
export function fmInvoice_page(params) {
    return request({
        url: '/fm/fmInvoice/page',
        headers: {
            isToken: true,
        },
        method: 'get',
        params,
    })
}

/**
 * 开票信息管理判断是否存在
 * @author ConFront_C_Eng
 * @date 2023-10-17 20:39:41
 */
export function judgeExistsFmInvoice(params) {
    return request({
        url: '/fm/fmInvoice/judgeExists',
        method: 'get',
        headers: {
            isToken: true,
        },
        params
    })
}
